export function getEmptyFilters() {
  return {
    group: [],
    availability: [],
    location: [],
    dayOfWeek: [],
    dates: [],
    difficulty: [],
    venueSearch: [], // Add this new field for venue search selections
    groupOpen: false,
    availabilityOpen: false,
    locationOpen: false,
    dayOfWeekOpen: false,
  };
}
